import React from 'react';
import PropTypes from 'prop-types';


function MissingEntriesTooltip({ date }) {
  return (
    <div className="messages status missing-entries-tooltip">
      Last filing was on { date }, you can update dockets for more recent filings.
    </div>
  );
}

MissingEntriesTooltip.propTypes = {
  date: PropTypes.string.isRequired,
};

export default MissingEntriesTooltip;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/LastFilingTooltip.jsx
 **/